import { Dispatch, SetStateAction, createContext } from 'react';

type MutationErrorContextType = {
  isMutationErrorModalShown: boolean;
  setIsMutationErrorModalShown: Dispatch<SetStateAction<boolean>>;
  mutationErrorMessage: string;
  setMutationErrorMessage: Dispatch<SetStateAction<string>>;
  errorCode?: number;
  setErrorCode: Dispatch<SetStateAction<number | undefined>>;
};

export const MutationErrorContext = createContext<MutationErrorContextType>({
  isMutationErrorModalShown: false,
  setIsMutationErrorModalShown: () => null,
  mutationErrorMessage: '',
  setMutationErrorMessage: () => null,
  errorCode: undefined,
  setErrorCode: () => null
});
